import React from "react";
import { Select } from "antd";
import SC from "./style.js";

const TimeZoneWithCountryDropdown = ({
  options = [],
  placeholder = "Select an option",
  value,
  onChange,
  style = {},
  disabled = false,
  width = "100%",
  height = "30px",
  margin,
  allowClear = false,
  filterOption,
  className = "",
  popupClassName = "",
  dropdownStyle = {},
  ...rest
}) => {
  return (
    <>
      {SC.Globalstyles}
      <Select
        className={`timezone-country-select ${className}`.trim()}
        popupClassName={`timezone-country-dropdown ${popupClassName}`.trim()}
        showSearch
        placeholder={placeholder}
        style={{
          width: width,
          height: height,
          margin: margin,

          ...style,
        }}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        allowClear={allowClear}
        getPopupContainer={() => document.body}
        listHeight={256}
        dropdownStyle={{
          maxHeight: "320px",
          overflowY: "auto",
          padding: "8px 0",
          ...dropdownStyle,
        }}
        {...rest}
        filterOption={
          filterOption ||
          ((input, option) => {
            const label = option.label
              ? option.label.toString().toLowerCase()
              : "";
            const value = option.value
              ? option.value.toString().toLowerCase()
              : "";
            return (
              label.includes(input.toLowerCase()) ||
              value.includes(input.toLowerCase())
            );
          })
        }
      />
    </>
  );
};

export default TimeZoneWithCountryDropdown;
